import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { saveToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// Landing page for the custom Google OAuth flow (`/auth/google/success`).
// The backend redirects the browser here with `#token=<jwt>&redirect=<path>`
// after a successful sign-in. We save the token, refresh the auth context,
// then send the user to their portal.
export default function GoogleAuthSuccess() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [msg, setMsg] = useState("Signing you in…");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams((window.location.hash || "").replace(/^#/, ""));
    const token = params.get("token");
    const redirect = params.get("redirect") || "/dashboard";
    const err = params.get("google_error");
    if (err) {
      setMsg(decodeURIComponent(err));
      setTimeout(() => navigate("/login", { replace: true }), 1500);
      return;
    }
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    saveToken(token);
    // Wipe the token out of the URL BEFORE refresh() reads /auth/me.
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        await refresh();
        navigate(redirect, { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
      <div className="text-[#7A7571] font-body" data-testid="google-auth-success-status">{msg}</div>
    </div>
  );
}
